import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { Options, on, isPrivacyAccepted } from "../utils/decorators";
import { translateMultiple } from "../utils/translator";
import DropdownView from "../views/dropdown-view";
import Favorites from '../favorites/favorites';

const FeedError = "FeedError";
const NotAvailable = "NotAvailable";
const NotOnSale = "NotOnSale";
const OnSale = "OnSale";
const SoldOut = "SoldOut";
const OffSale = "OffSale";

import NoButtons from "./views/made-no-buttons";
import NoSeatsAvailable from "./views/made-sold-out";
import NoLongerAvailable from "./views/made-off-sale";
import MadeButtons from "./views/made-buttons";

const BlocksOfficeDomain = (<any>window).DJANGO.mySiteDomain;

@Options({
    el: 'body',
    template: false,
    ui: {
        dynamicButtons: '[data-perfticketid]',
        acceptButton: "[data-js-ui=accept-button]",
    },
    regions: {
        buttonRegion: '#buy-button-target',
    },
})

export default class SimpleButtonsView extends Marionette.View<Backbone.Model>{
    _now = Date.now()
    _performanceStates = null
    _seriesStates = null
    _cyoStates = null
    _cyoPerformanceStates = null

    defaultPerfMos = 4
    defaultSeriesMos = 26
    defaultCYOMos = 5

    specialMos = {
        47: { series:47, cyo: 5 },
        48: { series:47, cyo: 5 },
    }

    buttonStates = {
        'NotOnSale NotOnSale NotOnSale': NoButtons,
        'NotAvailable NotAvailable NotAvailable': NoButtons,
        'SoldOut SoldOut SoldOut': NoSeatsAvailable,
        'OffSale OffSale OffSale': NoLongerAvailable,

        'NotOnSale OffSale SoldOut': NoButtons,
        'NotOnSale NotOnSale SoldOut': NoButtons,
        'NotOnSale SoldOut SoldOut': NoSeatsAvailable,
        'NotOnSale NotOnSale OffSale': NoButtons,
        'NotOnSale OffSale OffSale': NoButtons,

        'OffSale SoldOut SoldOut': NoSeatsAvailable,
        'OffSale OffSale SoldOut': NoSeatsAvailable,

        'NotAvailable NotAvailable NotOnSale': NoButtons,
        'NotAvailable NotOnSale NotOnSale': NoButtons,

        'NotAvailable SoldOut SoldOut': NoSeatsAvailable,
        'NotAvailable NotAvailable SoldOut': NoSeatsAvailable,
        'NotAvailable OffSale SoldOut': NoSeatsAvailable,
        'NotAvailable NotOnSale SoldOut': NoSeatsAvailable,
    }

    async onRender() {
        if (!this.ui.dynamicButtons.length) {
            return;
        }

        await this.loadData();
        this.generateButtons();

        this.addEvents();
    }

    async loadData(): Promise<any> {
        const modeOfSale = this.getMosFomCookie();
        const currentMode = this.determineMos();

        const blocksOfficeUrl = BlocksOfficeDomain;
        const origin = '&host=' + location.host;

        return Promise.all([
            this.loadStateData(blocksOfficeUrl + '/api/productions?mos=' + modeOfSale + origin, 'Performance', 'perf_no'),
            this.loadStateData(blocksOfficeUrl + '/api/packages?mos=' + currentMode.series + origin, 'Package', 'pkg_no'),
            this.loadStateData(blocksOfficeUrl + '/api/packages?mos=' + currentMode.cyo + origin, 'Package', 'pkg_no'),
            this.loadStateData(blocksOfficeUrl + '/api/productions?mos=' + currentMode.cyo + origin, 'Performance', 'perf_no'),
        ]).then(values => {
            this._performanceStates = values[0];
            this._seriesStates = values[1];
            this._cyoStates = values[2];
            this._cyoPerformanceStates = values[3];
        });
    }

    determineButtonView(perfStatus, seriesStatus, cyoStatus) {
        let key: any = [perfStatus, seriesStatus, cyoStatus];

        key.sort();

        key = key.join(' ');

        if (key in this.buttonStates) {
            return this.buttonStates[key];
        }

        return MadeButtons;
    }

    generateButtons() {
        this.ui.dynamicButtons.each(async (index: number, button: any) => {
            const data = $(button).data();

            let perf = this.getPerformance(data.perfticketid);
            let series = this.getSeries(data.seriesticketid);
            let cyo = this.getCYO(data.cyoticketid, data.perfticketid);

            let ButtonView = this.determineButtonView(perf.status, series.status, cyo.status);

            const view = new ButtonView({
                model: new Backbone.Model({
                    data, perf, series, cyo,
                }),
            })

            view.render();

            this.getRegion('buttonRegion').show(view);

            const $dropdown = $("[data-js-view='dropdown']");

            const dropDownView = new DropdownView({
                el: $dropdown,
            });

            // Add divider
            $('.dropdown__item + .dropdown__item', $dropdown).each(function () {
                $(this).before($('<li class="dropdown__item__divider">OR</li>'));
            });

            dropDownView.render();

            // Add body class for buttons
            if( $('.btn--buy-tickets').length || $('.not-for-sale').length || $('.btn--force').length ) {
                $('body').addClass('has-buy-button');
            }

            // Carry out additional translations
            const nodes = $('[data-auto-translate="true"]', this.getRegion('buttonRegion').el);

            const phrases = [];

            nodes.each(function () {
                phrases.push(this.innerHTML);
            });

            translateMultiple(phrases).then(translations => {
                nodes.each(function (index) {
                    this.innerHTML = translations[index].to;
                    this.setAttribute('data-auto-translate', 'false');
                });
            });
        });
    }

    getMosFomCookie() {
        const cookies = document.cookie.split('; ');

        let currentMOS = null;
        let basketCount = 0;
        let loginMos = 0;

        for (let i = 0; i < cookies.length; ++i) {
            let kv = cookies[i].split('=');

            if (kv[0] == '_bo_mos') {
                currentMOS = parseInt(kv[1], 10);
            } else if (kv[0] == '_bo_basket_count') {
                basketCount = parseInt(kv[1], 10);
            } else if (kv[0] == 'login_mos') {
                loginMos = parseInt(kv[1], 10);
            }
        }

        if (loginMos && loginMos === currentMOS) {
            return currentMOS;
        }

        if (currentMOS && basketCount) {
            return currentMOS;
        }

        return this.defaultPerfMos;
    }

    determineMos() {
        const mos = this.getMosFomCookie();

        if (_.has(this.specialMos, mos)) {
            return this.specialMos[mos];
        }

        return {
            series: this.defaultSeriesMos,
            cyo: this.defaultCYOMos,
        }
    }

    async loadStateData(url, resultsSectionName, resultsIdName): Promise<any> {
        return fetch(url, { mode: 'cors' }).then(response => {
            return response.json();
        }).then(results => {
            if (_.isEmpty(results)) {
                return {};
            }

            const inventory = results[resultsSectionName];
            const contents = results.WebContent;

            let states = {};

            for (let entity of results[resultsSectionName]) {
                const invNo = parseInt(entity[resultsIdName], 10);

                const availabilityOverride = _.find(contents, (content: any) => {
                    const forItem = (
                        parseInt(content.orig_inv_no, 10) === invNo || parseInt(content.inv_no, 10) === invNo
                    );

                    return forItem && parseInt(content.content_type, 10) === 24;
                });

                const isAvailable = _.some(entity.pricing ? entity.pricing : [], (price: any) => {
                    return  'tickets_available' in price && price.tickets_available;
                });

                let isAvailableOverride = null;

                if (availabilityOverride !== undefined) {
                    if (availabilityOverride.content_value === 'Available') {
                        isAvailableOverride = true;
                    } else if (availabilityOverride.content_value === 'Unavailable') {
                        isAvailableOverride = false;
                    }
                }

                let date = null;

                try {
                    date = Date.parse(entity.perf_date);
                } catch {}

                states[invNo] = {
                    purchaseStart: Date.parse(entity.start_dt),
                    purchaseEnd: Date.parse(entity.end_dt),
                    isAvailable: isAvailable,
                    isAvailableOverride: isAvailableOverride,
                    status: null,
                    perfDate: date
                };
            }

            return states;
        }).catch(() => {
            return FeedError;
        });
    }

    getPerformance(performanceId: string) {
        if (this._performanceStates === FeedError) {
            return { status: FeedError };
        }

        const performance = this._performanceStates[performanceId];

        if (!performance) {
            return {
                status: NotAvailable,
            }
        }

        if (performance.status !== null) {
            return performance;
        }

        if (!performance.purchaseStart || !performance.purchaseEnd) {
            // No start or end date
            performance.status = NotOnSale;
        } else if (performance.purchaseStart > this._now) {
            // Not yet on sale
            performance.status = NotOnSale;
        } else if (performance.purchaseEnd < this._now) {
            // Off sale
            performance.status = OffSale;
        } else if (performance.isAvailable === false) {
            // Sold out
            performance.status = SoldOut;
        } else {
            // On sale
            performance.status = OnSale;
        }

        // Availability override
        if (performance.isAvailableOverride === true) {
            performance.status = OnSale;
        } else if (performance.isAvailableOverride === false) {
            performance.status = NotOnSale;
        }

        this._performanceStates[performanceId] = performance;

        return performance;
    }

    getSeries(seriesId: string) {
        if (this._seriesStates === FeedError) {
            return { status: FeedError };
        }

        const series =  this._seriesStates[seriesId];

        if (!series) {
            return {
                status: NotAvailable,
            }
        }

        if (series.status !== null) {
            return series;
        }

        if (!series.purchaseStart || !series.purchaseEnd) {
            // No start or end date
            series.status = NotOnSale;
        } else if (series.purchaseStart > this._now) {
            // Not yet on sale
            series.status = NotOnSale;
        } else if (series.purchaseEnd < this._now) {
            // Off sale
            series.status = OffSale;
        } else if (series.isAvailable === false) {
            // Sold out
            series.status = SoldOut;
        } else {
            // On sale
            series.status = OnSale;
        }

        this._seriesStates[seriesId] = series;

        return series;
    }

    getCYO(cyoId: string, performanceId: string) {
        if (this._cyoStates === FeedError) {
            return { status: FeedError };
        }

        const cyo =  this._cyoStates[cyoId];

        if (!cyo) {
            return {
                status: NotAvailable,
            }
        }

        if (cyo.status !== null) {
            return cyo;
        }

        const cyoPerformance = this._cyoPerformanceStates[performanceId];

        if (!cyo.purchaseStart || !cyo.purchaseEnd) {
            // No start or end date
            cyo.status = NotOnSale;
        } else if (cyo.purchaseStart > this._now) {
            // Not yet on sale
            cyo.status = NotOnSale;
        } else if (cyo.purchaseEnd < this._now) {
            // Off sale
            cyo.status = OffSale;
        } else if (cyoPerformance && cyoPerformance.isAvailable === false) {
            // Sold out
            cyo.status = SoldOut;
        } else {
            // On sale
            cyo.status = OnSale;
        }

        this._cyoStates[cyoId] = cyo;

        return cyo;
    }

    @on("click @ui.acceptButton")
    onAcceptButtonClick(e) {
        let vw = window.screen.width;
        let vh = window.innerHeight;
        let btn;

        if (btn = <HTMLElement>document.querySelector('.btn--buy-tickets')) {
            btn.style.borderBottomWidth = 15 + 'px';

            if (vw < 576) {
                let title = <HTMLElement>document.querySelector('.panel__title');
                let panelContent = <HTMLElement>document.querySelector('.panel--content');
                let gradientEl = <HTMLElement>document.querySelector('.panel--gradient');

                let btn, mediaPanel;

                if (btn = <HTMLElement>document.querySelector('.btn--buy-tickets')) {
                    btn.style.borderBottomWidth = 15 + 'px';

                    if (document.querySelector('.panel__times') && !document.querySelector('.split-panel--non-overlay')) {
                        let offsetVal = panelContent.offsetHeight - title.offsetHeight - 25 + 'px';
                        mediaPanel.style.paddingBottom = offsetVal;
                        gradientEl.style.marginBottom = '0';

                        mediaPanel.style.backgroundColor = '#231f20';
                    }

                }
            }
        }
    }

    addEvents() {
        let href = Favorites.getBlocksofficeURL();

        let cyoButtons = document.querySelectorAll('.js-cyo-favorites-button');
        for(let i = 0; i<cyoButtons.length; i++) {
            let button = cyoButtons[0];

            button.setAttribute('href', href);

            button.addEventListener('click', event => {
                event.preventDefault();
                let perfID = button.getAttribute('data-perf-id');
                let perfDate = button.getAttribute('data-perf-date');

                let perfDateNumber = 0;

                if(!perfDate) {
                    // backup to get timestamp ... hacky!
                    console.log('couldnt get perf time, grabbing it from favorites button');
                    let favoriteButton = document.querySelector('.favorite-button');
                    perfDateNumber = +favoriteButton.getAttribute('data-timestamp');
                } else {
                    perfDateNumber = (+perfDate) / 1000;
                }

                if(perfID && perfDateNumber) {
                    Favorites.favorite(+perfID, perfDateNumber);

                    setTimeout(() => {
                        window.location.href = href;
                    }, 50);
                } else {
                    console.warn('some error getting perf ID from button?');
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/button-logic/simple-buttons-view.ts